<template>

	<section id="Metrology">

		<div id="DidYouKnow">

			<div class="dyk-toggle" :class="{show: showDidYouKnowToggle}">

				<img :src="getDYK()" alt="Did you know?" v-on:click="showDidYouKnow = !showDidYouKnow" />

			</div>

			<div class="dyk-popup" :class="{show: showDidYouKnow}">

				<div class="dyk-popup__title">

					{{ $t('metrologyOfInnerAndOuter') }}

				</div>

				<div class="dyk-popup__text">

					{{ $t('whenAssembled') }}<br />
					{{ $t('otherwiseTheFunctionality') }}<br />
					{{ $t('withTheHelp') }}

				</div>

				<div class="dyk-popup__link">

					<a id="DYKLink" @click="showImagePopup = true">

						{{ $t('checkOutTheAccurate') }}

					</a>

				</div>

			</div>

		</div>

		<div id="Model"></div>

		<Popup
			:width="activePopup.width"
			:height="activePopup.height"
			:type="activePopup.type"
			:title="activePopup.title"
			:text="activePopup.text"
			:left="activePopup.left"
			:top="activePopup.top"
			:image="activePopup.image"
			:video="activePopup.video"
			:direction="activePopup.direction"
			bgcolor="black"
		></Popup>

		<div id="ImagePopup" v-if="showImagePopup">

			<img class="popup-image" :src="imagePopup()" alt="Popup" />

			<img class="close" src="/image/close.png" alt="Close" @click="showImagePopup = false" />

		</div>

	</section>

</template>

<script>

	import Model from "../../model";
	import Popup from "../Popup";
	import i18n from '@/plugins/i18n';

	export default {
		data () {
			return {
				activePopup: {
					id: null,
					width: 0,
					height: 0,
					type: null,
					title: null,
					text: null,
					image: '',
					video: '',
					left: 0,
					top: 0,
					direction: ''
				},
				showImagePopup: false,
				showDidYouKnowToggle: false,
				showDidYouKnow: false,
				popups: [
					{
						id: 'A',
						width: 924,
						height: 768,
						type: 'vertical',
						title: this.$t('nominalActualComparison'),
						text: this.$t('deviationsFromTheCAD'),
						image: '/image/metrology/nominal_actual_comparison.jpg',
						video: ''
					},
					{
						id: 'B',
						width: 924,
						height: 768,
						type: 'vertical',
						title: this.$t('dimensionalControl'),
						text: this.$t('thanksToComputed'),
						image: '/image/metrology/dimensional_control.jpg',
						video: ''
					},
					{
						id: 'C',
						width: 924,
						height: 768,
						type: 'vertical',
						title: this.$t('wallThicknessAnalysis'),
						text: this.$t('aColorCodedRepresentation'),
						image: '/image/metrology/wall_thickness_analysis.jpg',
						video: ''
					}
				]
			};
		},
		mounted () {
			Model.startMetrology(this.onClick);
			setTimeout(() => this.showDidYouKnowToggle = true, 500);
		},
		methods: {
			imagePopup() {
				return '/image/xrayseries/systems/0.'+ i18n.locale +'.png';
			},
			onClick (hotspot) {

				if (event.target.id === 'DYKLink') {
					return;
				}

				this.showDidYouKnow = false;
				let tm = this.activePopup.direction === '' ? 0 : 500;

				this.activePopup = {
					id: null,
					width: this.activePopup.width,
					height: this.activePopup.height,
					type: null,
					title: null,
					text: null,
					image: '',
					video: '',
					left: this.activePopup.left,
					top: this.activePopup.top,
					direction: ''
				};

				if (hotspot === null) {
					return;
				}

				setTimeout(() => {
					for (let popup of this.popups) {
						if (popup.id === hotspot.name) {
							this.activePopup = popup;
							let direction = '';

							if (hotspot.position.y >= 520) {
								direction = 'top';
							} else {
								direction = 'bottom';
							}

							if (hotspot.position.x >= 960) {
								direction += 'left';
							} else {
								direction += 'right';
							}

							this.activePopup.left = hotspot.position.x;
							this.activePopup.top = hotspot.position.y;
							this.activePopup.direction = direction;
						}
					}
				}, tm);
			},
			getDYK () {

				return `/image/dyk-black.${ i18n.locale }.png`;

			}
		},
		components: {
			Popup
		}
	};

</script>
